











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityCard_template",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityLibraryCardDescription_template"
    }
  ],
  "type": "MeetingTemplate",
  "abstractKey": "__isMeetingTemplate"
};

(node ).hash = "829306f852910405f99a36fe464a85fd";

export default node;
